import { getAuthAxiosBackend } from "@/helpers/axios"

class IssuersPassportsServices {
    get(id) {
        return getAuthAxiosBackend().get('IssuersPassports/getIssuersPassportsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('IssuersPassports/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('IssuersPassports/addIssuersPassports', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('IssuersPassports/updateIssuersPassports/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('IssuersPassports/restoreIssuersPassports' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('IssuersPassports/softDeleteIssuersPassports/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('IssuersPassports/deleteIssuersPassports/' + id.toString())
    }
}

export default new IssuersPassportsServices()
